import { TOOLTIP } from "../../constant";
const ThumbUp = (props) => {
  const { liked, onClick } = props;
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      role="img" 
      aria-label="Thumb Up"
    >
      <path
        d="M8.10508 16.6658V16.6655V10.1495C8.10508 9.26238 8.39281 8.3992 8.92508 7.6895L10.605 5.4504L10.6051 5.4503C11.3191 4.49827 11.7051 3.34034 11.7051 2.1503V1.3499C11.7051 1.21729 11.7578 1.09012 11.8515 0.996349C11.9453 0.902581 12.0725 0.849902 12.2051 0.849902C12.6559 0.849902 13.0883 1.02901 13.4072 1.34782C13.726 1.66663 13.9051 2.09903 13.9051 2.5499V7.3499V8.0499H14.6051H18.877C18.877 8.0499 18.8771 8.0499 18.8771 8.0499C19.1285 8.04994 19.3769 8.10576 19.6041 8.21335C19.8315 8.32094 20.0321 8.47763 20.1915 8.67211C20.3509 8.86659 20.4652 9.09403 20.5262 9.33803C20.5871 9.58199 20.5931 9.83644 20.5439 10.083C20.5439 10.083 20.5439 10.0831 20.5439 10.0831L19.1039 17.283L19.1039 17.2831C19.0268 17.6686 18.8185 18.0155 18.5144 18.2647C18.2104 18.5139 17.8293 18.6501 17.4362 18.6499H17.4359H10.9369C10.9368 18.6499 10.9368 18.6499 10.9367 18.6499C10.3009 18.6497 9.67392 18.5016 9.10522 18.2174L9.04532 18.1874L9.04518 18.1873C8.76258 18.0461 8.52493 17.8289 8.35887 17.5602C8.19281 17.2914 8.10493 16.9817 8.10508 16.6658ZM0.905078 10.7499C0.905078 10.0319 1.48711 9.4499 2.20508 9.4499H4.20508C4.92305 9.4499 5.50508 10.0319 5.50508 10.7499V16.9999C5.50508 17.7179 4.92305 18.2999 4.20508 18.2999H2.20508C1.48711 18.2999 0.905078 17.7179 0.905078 16.9999V10.7499Z"
        stroke={liked ? "#26A568" : "#576579"}
        fill={liked ? "#26A568" : ""}
        strokeWidth="1.4"
      />
    <title>{TOOLTIP.LIKE}</title>
    </svg>
  );
};

export default ThumbUp;
